import * as React from 'react';
import { GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector } from '@mui/x-data-grid';

/* BUTTONS -> VARIANT: "text" , "contained" , "outlined" */
export const v_button_variant = "contained";
/* BUTTONS -> SIZE: "small" , "medium" , "large" */
export const v_button_size = "small";
/* TOOLBAR DIVIDER */
export const v_toolbar_divider = ''; //<Divider orientation="vertical" flexItem />;

/* TABLE CONFIGURATION -> PageSize */
export const v_pageSize = 50;
/* TABLE CONFIGURATION -> rows per Page (1-3) */
export const v_rowsPerPageOptions_1 = 50;
/* TABLE CONFIGURATION -> rows per Page (2-3) */
export const v_rowsPerPageOptions_2 = 100;
/* TABLE CONFIGURATION -> rows per Page (3-3) */
export const v_rowsPerPageOptions_3 = 200;
/* TABLE CONFIGURATION -> table toolbar visible = true/false */
export const v_table_toolbar_components = false;
/* TABLE CONFIGURATION -> table density  */
export const v_table_density = 'compact'; // compact, standard, comfortable

export const Grid_CSS = "";

export const public_date_time_format = "DD/MM/YYYY hh:mm A";
export const public_date_format = "DD/MM/YYYY";

export function CustomToolbar() {
    return (
      <div>     
              {
                  (() => {
                      if(v_table_toolbar_components===true) {
                              return (
                                <GridToolbarContainer >
                                  <GridToolbarColumnsButton />
                                  <GridToolbarFilterButton />
                                  <GridToolbarDensitySelector />
                                </GridToolbarContainer>                          
                              )
                          } else {
                              return (
                                null
                              )
                          }
                  })()  
              }  
      </div>  
    );
  }

